import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export const OrderDetails = () => {

    const { id } = useParams();
    const [order, setOrder] = useState(null);
    useEffect(() => {

        const token = sessionStorage.getItem("token");

        fetch(`${process.env.REACT_APP_API_URL}/order/${id}`, {
            headers: {
                Authorization: "Bearer " + token
            }
        })
            .then((res) => res.json())
            .then((data) => {
                console.log("ORDER =", data);
                setOrder(data);
            });

    }, [id]);

    return (
        <div className="container mt-5">

            <h2>Order Details</h2>

            {order && (
                <div className="card p-4 mt-4">

                    <h4>Order ID: {order.orderId}</h4>

                    <p>
                        <strong>Amount:</strong> ₹{order.totalAmount}
                    </p>

                    <p>
                        <strong>Payment ID:</strong> {order.paymentId}
                    </p>

                    <p>
                        <strong>Payment Status:</strong> {order.paymentStatus}
                    </p>

                    <p>
                        <strong>Order Status:</strong> {order.orderStatus}
                    </p>

                    <p>
                        <strong>Order Date:</strong> {order.orderDate}
                    </p>

                </div>
            )}

        </div>
    );
};